import {useQuery} from 'react-query';
import {getTransaction} from '.';
import {useNavigate} from 'react-router-dom';

const useGetTransaction = (params: GetTransactionPayload) => {
  const navigate = useNavigate();
  const {data, isLoading} = useQuery({
    queryKey: ['transaction', params],

    queryFn: () => getTransaction(params),
    onSuccess(data) {
      data &&
        data.status &&
        navigate(
          data.status === 'successful'
            ? '/payment/success'
            : `/payment/failure/${params.ipg_type}/${params.guid}`,
          {state: {data}},
        );
    },
    enabled: params.guid ? true : false,
  });
  return {data, isLoading};
};

export default useGetTransaction;
